import type { Config } from "tailwindcss";
import animate from "tailwindcss-animate";

export default {
	darkMode: "class",
	content: ["./index.html", "./src/**/*.{ts,tsx}"],
	prefix: "",
	theme: {
		container: {
			center: true,
			padding: "2rem",
			screens: {
				"2xl": "1400px",
			},
		},
		extend: {
			fontFamily: {
				sans: ["Montserrat", "sans-serif"],
				inter: ["Inter", "sans-serif"],
				afacad: ["Afacad", "sans-serif"],
			},
			fontSize: {
				xxs: "8px",
				sm: "10px",
				base: "12px",
				lg: "14px",
				xl: "20px",
				chat: "var(--font-size-chat)",
				"chat-lg": "var(--font-size-chat-lg)",
				"chat-md": "var(--font-size-chat-md)",
			},
			maxHeight: {
				base: "calc(100% - 32px)",
				"without-btn": "calc(100% - 26px)",
				"fields-info": "calc(100% - 80px - 32px)",
				"fields-tablet-base": "calc(100% - 64px)",
				"fields-tablet-info": "calc(100% - 80px - 64px)",
				filings: "calc(100% - 43px)",
				"num-filters": "calc(100% - 68px)",
			},
			colors: {
				border: {
					DEFAULT: "var(--border)",
					light: "#6a6a6a",
					hover: "#7e7e7e",
					main: "#505051",
				},
				input: "var(--input)",
				ring: "var(--ring)",
				bronze: "var(--bronze)",
				gold: "var(--gold)",
				silver: "var(--silver)",
				platinum: "var(--platinum)",
				brief: "var(--brief)",
				success: "var(--success)",
				"success-light": "var(--success-light)",
				error: "var(--error)",
				"error-light": "var(--error-light)",
				white: "var(--white)",
				gray: "var(--gray)",
				"light-gray": "var(--light-gray)",
				tooltip: "var(--tooltip)",
				background: "var(--background)",
				darkBackground: "var(--dark-background)",
				modal: "var(--background-modal)",
				foreground: "var(--foreground)",
				link: "var(--link)",
				primary: {
					DEFAULT: "var(--primary)",
					foreground: "var(--primary-foreground)",
				},
				secondary: {
					DEFAULT: "var(--secondary)",
					foreground: "var(--secondary-foreground)",
				},
				destructive: {
					DEFAULT: "var(--destructive)",
					foreground: "var(--destructive-foreground)",
				},
				muted: {
					DEFAULT: "var(--muted)",
					foreground: "var(--muted-foreground)",
				},
				accent: {
					DEFAULT: "var(--accent)",
					foreground: "var(--accent-foreground)",
				},
				popover: {
					DEFAULT: "var(--popover)",
					foreground: "var(--popover-foreground)",
				},
				card: {
					DEFAULT: "var(--card)",
					foreground: "var(--card-foreground)",
				},
				epsm: {
					up: "#1bc721",
					down: "#ff2323",
				},
				volumes: {
					up: "rgba(24, 173, 147, 0.5)",
					down: "rgba(247, 82, 95, 0.5)",
				},
				gradient: "hsl(60, 5%, 12.1%)",
				consolidation: "#f3bd3e",
				orange: "#ee7600",
				lightYellow: "#ffffc5",
			},
			borderRadius: {
				lg: "var(--radius)",
				md: "calc(var(--radius) - 2px)",
				sm: "calc(var(--radius) - 4px)",
			},
			keyframes: {
				"accordion-down": {
					from: {
						height: "0",
					},
					to: {
						height: "var(--radix-accordion-content-height)",
					},
				},
				"accordion-up": {
					from: {
						height: "var(--radix-accordion-content-height)",
					},
					to: {
						height: "0",
					},
				},
			},
			animation: {
				"accordion-down": "accordion-down 0.2s ease-out",
				"accordion-up": "accordion-up 0.2s ease-out",
			},
		},
	},
	plugins: [animate],
} satisfies Config;
